import { call, put } from 'redux-saga/effects';

import { intl } from '@helpers/intl';
import { jurisdictionsFailure } from '@store/jurisdictions';

import { fetchJurisdictionsSaga } from '../fetchJurisdictionsSaga';

export const handleFetchJurisdictionsRequest = function* ({ payload }) {
  try {
    yield call(fetchJurisdictionsSaga, { payload });
  } catch (error) {
    const message =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'Failed to fetch jurisdictions.',
        id: 'saga.jurisdictions.failure',
      });

    yield put(jurisdictionsFailure({ errorMessage: message }));
  }
};
